import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Button from './Button';
import Icon from '../AppIcon';

const OAuthButtons = ({ mode = 'signin', disabled = false, onSuccess, onError }) => {
  const { signInWithGoogle } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleGoogleAuth = async () => {
    if (disabled || isLoading) return;

    setIsLoading(true);
    try {
      const result = await signInWithGoogle();
      
      if (result?.success) {
        onSuccess?.();
      } else {
        onError?.(result?.error || 'Google authentication failed');
      }
    } catch (error) {
      console.error('Google auth error:', error);
      onError?.(error?.message || 'Something went wrong with Google authentication');
    } finally {
      setIsLoading(false);
    }
  };

  const buttonText = mode === 'signin' ? 'Sign in with Google' : 'Sign up with Google';
  const buttonIcon = 'Chrome'; // Using Chrome icon as Google icon alternative

  return (
    <div className="space-y-3">
      {/* Google OAuth Button */}
      <Button
        type="button"
        variant="outline"
        fullWidth
        onClick={handleGoogleAuth}
        disabled={disabled || isLoading}
        loading={isLoading}
        className="h-12 border-2 hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 group"
      >
        <div className="flex items-center justify-center space-x-3">
          <div className="w-5 h-5 flex items-center justify-center">
            {isLoading ? (
              <div className="w-4 h-4 border-2 border-text-muted border-t-transparent rounded-full animate-spin"></div>
            ) : (
              <Icon 
                name={buttonIcon} 
                size={20} 
                className="text-text-secondary group-hover:text-primary transition-colors"
              />
            )}
          </div>
          <span className="font-medium text-text-primary group-hover:text-primary transition-colors">
            {isLoading ? 'Connecting...' : buttonText}
          </span>
        </div>
      </Button>

      {/* Alternative OAuth providers can be added here */}
      {/* Example: GitHub, Microsoft, etc. */}
      
      {/* Divider */}
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-2 bg-surface text-text-muted">or continue with email</span>
        </div>
      </div>
    </div>
  );
};

export default OAuthButtons; 